function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSmileBk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "osu1wm00ga"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 215",
    style: {
      fill: "#232323"
    },
    d: "M0 0h12v12H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 4837",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9438"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 3",
    style: {
      clipPath: "url(#osu1wm00ga)"
    },
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 2",
    d: "M6 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6M2.765 4.7a.914.914 0 1 1 .914.915.914.914 0 0 1-.914-.915M6.01 9.646a2.412 2.412 0 0 1-2.465-2.355h4.93A2.412 2.412 0 0 1 6.01 9.646M8.321 5.61a.914.914 0 1 1 .914-.91.915.915 0 0 1-.915.915",
    style: {
      fill: "#232323"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSmileBk);
export default __webpack_public_path__ + "static/media/ico-smile-bk.20ea81a39cab5ba6af40ac1ae7a29baa.svg";
export { ForwardRef as ReactComponent };